import React from 'react';
import { Toggle } from '@cimpress/react-components';

const WHITE = '#ffffff';

interface ColorProps {
    color: string;
    id: string;
    toggleColor: (id: string) => void;
}

const Color: React.FC<ColorProps> = ({ color, toggleColor, id }) => {
    return (
        <div className='ruler-color'>
            Light mode
            <Toggle on={color === WHITE} onClick={() => toggleColor(id)} />
        </div>
    );
};

export default React.memo(Color);
